import { Component, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FullscreenService } from '@core/services/common';
import {  DpadKeyCode, DpadZoneType, ROUTE_PATH, TV_CSS} from '@core/constants';
import { DpadControlService } from '@core/services/common/dpad-control.service';
import { TvService } from '@core/services/common/tv.service';
import { Subscription } from 'rxjs';
import { DpadZoneState } from '@core/models/models';

@Component({
  selector: 'app-layout-tv',
  templateUrl: './layout-tv.component.html',
  styleUrl: './layout-tv.component.scss',
  encapsulation: ViewEncapsulation.None,
})

export class LayoutTvComponent implements OnDestroy {
  DpadZoneType = DpadZoneType;
  visible: string = TV_CSS.VISIBLE;
  subscription: Subscription = new Subscription();
  isScreens: boolean = false;
  dpadX: number = -1;
  dpadY: number = -1;

  constructor(
    private fullScreenService: FullscreenService,
    private dpadControlService: DpadControlService,
    private router: Router,
    private tvService: TvService,
  ){ }

  ngOnInit(): void {
    this.setDefaultTvMode();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setDefaultTvMode(){
    document.body.classList.add('dark');
    const current = this.fullScreenService.fullscreenStateSubject.getValue();
    [
      this.fullScreenService.fullscreenStateSubject.next({ ...current, isFullscreen: true}),
      this.dpadControlService.dZoneState$.subscribe((state: DpadZoneState) => {
        if(state.dZone == DpadZoneType.TV_LAYOUT){
          this.isScreens = true;
          this.dpadX = state.dX,
          this.dpadY = state.dY
        }
        else if (this.shouldOpenFocusedMenuItem(state)) {
          this.isScreens = false;
          window.dispatchEvent(new CustomEvent('tv-blank-back'));
        }
        else this.isScreens = false;
    })].forEach(sub => this.subscription.add(sub));
  }

  private shouldOpenFocusedMenuItem(state: DpadZoneState): boolean {
    const isBackOrMenu = state.dKey == DpadKeyCode.KEYCODE_BACK || state.dKey == DpadKeyCode.KEYCODE_MENU;
    const isUpIntoBlankScreen = state.dZone == DpadZoneType.SCREEN && state.dKey == DpadKeyCode.KEYCODE_DPAD_UP;
    if (!isBackOrMenu && !isUpIntoBlankScreen) return false;
    if (this.isTvBlankRoute()) return true;
    return this.isTvMenuShowRoute() && !this.tvService.getDataMenuTvSelectedSnapshot();
  }

  private isTvBlankRoute(): boolean {
    const currentUrl = this.router.url.replace(/^\/+/, '').split('?')[0];
    return currentUrl === ROUTE_PATH.TV_BLANK;
  }

  private isTvMenuShowRoute(): boolean {
    const currentUrl = this.router.url.replace(/^\/+/, '').split('?')[0];
    return currentUrl === ROUTE_PATH.TV_MENU_SHOW || currentUrl === ROUTE_PATH.TV_MENU_SHOW_YB;
  }
  
}
